import React, { useState } from 'react'
import { Panel, Row, Col, Form, Message } from 'rsuite'
import CKEditorFrom from '../../components/forms/input/CKEditorFrom'

export default function QualificationResponsibleForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)

  return (
    <>
      <Form>
        <Panel>
          <Row>
            {schema.educationHistory && (
              <Col>
                {schema.educationHistory.alert && (
                  <Message
                    style={{ marginBottom: 10 }}
                    showIcon
                    type="warning"
                    description={schema.educationHistory.alert}
                  />
                )}
                <CKEditorFrom
                  schema={schema.educationHistory}
                  // toolbar={[]}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            )}

            {schema.experience && (
              <Col>
                {schema.experience.alert && (
                  <Message
                    style={{ marginBottom: 10 }}
                    showIcon
                    type="warning"
                    description={schema.experience.alert}
                  />
                )}
                <CKEditorFrom
                  schema={schema.experience}
                  // toolbar={[]}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            )}

            {schema.expertiseAreas && (
              <Col>
                {schema.expertiseAreas.alert && (
                  <Message
                    style={{ marginBottom: 10 }}
                    showIcon
                    type="warning"
                    description={schema.expertiseAreas.alert}
                  />
                )}
                <CKEditorFrom
                  schema={schema.expertiseAreas}
                  // toolbar={[]}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            )}
          </Row>
        </Panel>
      </Form>
    </>
  )
}
